import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import {
  List,
  Datagrid,
  EditButton,
  Create,
  SimpleForm,
  TextInput,
  Edit,
  Filter,
  BulkDeleteButton,
  Toolbar,
  SaveButton,
  DeleteButton,
  required,
  TextField,
  usePermissions,
  useRecordContext,
  ListButton,
} from 'react-admin';

const CaracteristicasTitle = () => {
  const record = useRecordContext();
  if (!record) return null;

  return <span>Característica {record.name}</span>;
};

const CaracteristicasFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Procurar" source="q" alwaysOn />
  </Filter>
);

const PostBulkActionButtons = ({ permissions, ...props }) => (
  <>
    {!permissions.isLoading &&
      (permissions.permissions.includes('SYS_ADMIN') ||
        permissions.permissions.includes('ROLE_CARACTERISTICAS_DELETE')) && (
        <BulkDeleteButton {...props} />
      )}
  </>
);

export const Caracteristicas = (props) => {
  const permissions = usePermissions();

  return (
    <List
      perPage={25}
      title="Caracteristicas"
      filters={<CaracteristicasFilter />}
      sort={{ field: 'id', order: 'DESC' }}
      {...props}
    >
      <Datagrid
        bulkActionButtons={<PostBulkActionButtons permissions={permissions} />}
      >
        <TextField label="Nome" source="name" />
        {!permissions.isLoading &&
          (permissions.permissions.includes('SYS_ADMIN') ||
            permissions.permissions.includes(
              'ROLE_CARACTERISTICAS_UPDATE',
            )) && <EditButton />}
      </Datagrid>
    </List>
  );
};

const CustomToolbar = ({ permissions, ...props }) => (
  <Toolbar
    {...props}
    className="botoesUpdate"
    style={{ justifyContent: 'space-between' }}
  >
    <div
      style={{
        width: '250px',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <SaveButton alwaysEnable />
      <ListButton
        size="medium"
        variant="outlined"
        label="cancelar"
        icon={<CloseIcon />}
      />
    </div>
    {!permissions.isLoading &&
      (permissions.permissions.includes('SYS_ADMIN') ||
        permissions.permissions.includes('ROLE_CARACTERISTICAS_DELETE')) && (
        <DeleteButton size="medium" />
      )}
  </Toolbar>
);

export const CaracteristicasEdit = (props) => {
  const permissions = usePermissions();

  return (
    <Edit redirect="list" title={<CaracteristicasTitle />} {...props}>
      <SimpleForm toolbar={<CustomToolbar permissions={permissions} />}>
        <TextInput label="Nome" fullWidth source="name" validate={required()} />
      </SimpleForm>
    </Edit>
  );
};

export const CaracteristicasCreate = (props) => {
  const permissions = usePermissions();

  return (
    <Create redirect="list" {...props}>
      <SimpleForm toolbar={<CustomToolbar permissions={permissions} />}>
        <TextInput label="Nome" fullWidth source="name" validate={required()} />
      </SimpleForm>
    </Create>
  );
};

export default Caracteristicas;
